import { LocalNavigationModel } from './local-navigation.model';

export class NavigationModel {
  hideTitle: boolean | null = false;
  localNavigation: LocalNavigationModel | null = null;
  title: string;
  visibleMainNav = true;
}
